var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBymarkLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 963.78 963.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e2017b;stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m481.89,0C215.75,0,0,215.75,0,481.89s215.75,481.89,481.89,481.89,481.89-215.75,481.89-481.89S748.03,0,481.89,0Zm-214.56,708.18s-144.23-14.45-129.75-89.11l89.11-459.61h82.86l-42.21,218.86s50.03-57.84,126.63-57.84,106.3,93.8,106.3,93.8c0,0,30.48,293.9-232.93,293.9Zm415.84-9.38c-90.67,162.58-181.83,170.4-181.83,170.4l-17.08-70.35c101.24-21.89,141.07-126.63,141.07-126.63l-82.86-343.93h78.17l53.14,267.76,118.82-267.76h84.42s-103.18,207.92-193.85,370.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m225.12,623.76s6.25-232.93,125.06-239.19c118.81-6.25,45.34,173.53,45.34,173.53,0,0-76.6,125.06-170.4,65.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBymarkLogo);
export default __webpack_public_path__ + "static/media/Bymark_Logo.61c3eaa1f71906a087cb4cf5e94e4a9f.svg";
export { ForwardRef as ReactComponent };